<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-4">
            <div class="form-group">
              <label for="">聯絡資訊</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.keyword"
                @keyup.enter="getContactInfo"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getContactInfo"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#contactInfoModal"
              @click="contactInfoModal({ action: 'add' })"
            >
              {{ i18n("Buttons.Add") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#contactInfoModal"
            @click="contactInfoModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="Delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delContactInfoModal"
            @click="contactInfoData = { ...props.row }"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      id="contactInfoModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="contactInfo"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增聯絡資訊</span>
              <span v-else>編輯聯絡資訊</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  name="聯絡資訊"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="">
                    <span class="mark">*</span>
                    聯絡資訊
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="100"
                    v-model.trim="contactInfoData.Name"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveContactInfo)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delContactInfoModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除聯絡資訊</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ contactInfoData.Name }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delContactInfo"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "ContactInfoMaintenance",

  data() {
    return {
      // 判斷新增、編輯
      action: "add",

      contactInfoData: {},

      search: {},
      
      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "聯絡資訊",
          name: "Name",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
        {
          label: "",
          name: "Delete",
          slot_name: "Delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getContactInfo();
    },

    // 取得 聯絡資訊
    getContactInfo() {
      this.updateLoading(true);
      this.$api.contactInfo
        .getContactInfoPaging({
          ...this.search,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Data;
            this.totalData = response.data.SearchQuantity;
          }
          this.updateLoading(false);
        });
    },

    // 聯絡資訊 Modal
    contactInfoModal({ action, data }) {
      switch (action) {
        case "add":
          this.contactInfoData = {};
          this.action = "add";
          break;
        case "edit":
          this.contactInfoData = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.contactInfo.reset();
    },

    // 新增、編輯 聯絡資訊
    saveContactInfo() {
      $("#contactInfoModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.contactInfo
            .postContactInfo({
              Name: this.contactInfoData.Name,
              CreateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getContactInfo();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.contactInfo
            .putContactInfo({
              ...this.contactInfoData,
              UpdateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getContactInfo();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 聯絡資訊
    delContactInfo() {
      this.updateLoading(true);
      this.$api.contactInfo
        .deleteContactInfo({
          Guid: this.contactInfoData.Guid
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getContactInfo();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  created() {
    this.getContactInfo();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
